import * as Sentry from "@sentry/react";
import { runtimeEnv } from "@/lib/runtime-env";
export default function () {
    const isDevelopment = import.meta.env.DEV
    const samplingRate = ((v: string | undefined) => {
        const standard = isDevelopment ? 1 : 0.1
        if (!v) {
            return standard
        }
        try {
            return parseFloat(v)
        } catch {
            return standard
        }
    })(runtimeEnv('VITE_SENTRY_SAMPLE_RATE'))
    Sentry.init({
        dsn: runtimeEnv('VITE_SENTRY_DSN'),
        sendDefaultPii: true,
        integrations: [
            Sentry.browserTracingIntegration({
                ignoreResourceSpans: ["resource.script", "resource.img"],
                enableReportPageLoaded: false,
                instrumentPageLoad: false,
                instrumentNavigation: false,
                _experiments: {
                    enableInteractions: false,
                    enableStandaloneClsSpans: false,
                    enableStandaloneLcpSpans: false
                }
            })
        ],
        tracesSampleRate: samplingRate,

        tracePropagationTargets: [
            /^https?:\/\/localhost(:\d+)?/,
            runtimeEnv('VITE_AI_SERVICE') ?? '',
        ],
        environment: runtimeEnv('VITE_SENTRY_ENVIRONMENT') ?? (isDevelopment ? 'development' : 'production'),
    });
}
